import { styled } from '@mui/material';

import { useReportContext } from '../../../../context/useReportContext';
import { ChallengePrompt } from './components/ChallengePrompt';

const StyledHeader = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: theme.spacing(5),
}));

export const MainHeader = () => {
  const { shareReportButton } = useReportContext();

  return (
    <StyledHeader>
      <ChallengePrompt />
      {shareReportButton}
    </StyledHeader>
  );
};
